import { render, staticRenderFns } from "./moor-switch.vue?vue&type=template&id=355d4250&scoped=true&"
import script from "./moor-switch.vue?vue&type=script&lang=js&"
export * from "./moor-switch.vue?vue&type=script&lang=js&"
import style0 from "./moor-switch.vue?vue&type=style&index=0&id=355d4250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.5.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d4250",
  null
  
)

component.options.__file = "moor-switch.vue"
export default component.exports